export const LIST = {
  tags: [],
  category: '',
  init: () => {
    $('#map-nav .items .item').on('click', LIST.open);
    $('#sec-list-close').on('click', LIST.close);
    $('#list-category .item').on('click', LIST.sort);
    $('#list-filter .tag').on('click', LIST.filter);
  },
  open: function() {
    LIST.resetTags();

    LIST.category = $(this).data('category');
    $('#sec-list').attr({class: 'sec-list ' + LIST.category}).stop(true,false).fadeIn(200, 'swing').scrollTop(0);
  },
  close: function() {
    $('#sec-list').stop(true,false).fadeOut(200, 'swing');
  },
  sort: function() {
    LIST.resetTags();

    LIST.category = $(this).data('category');
    $('#sec-list').attr({class: 'sec-list ' + LIST.category});
  },
  filter: function() {
    const tag = $(this).data('tag');

    if ($(this).hasClass('enabled')) {
      $(this).removeClass('enabled');
      const index = LIST.tags.indexOf(tag);
      LIST.tags.splice(index, 1);
    } else {
      $(this).addClass('enabled');
      LIST.tags.push(tag);
    }

    // console.log(LIST.tags)

    if (!LIST.tags.length) {
      $('#sec-list .facilities[data-category="'+ LIST.category +'"] .item').css({display: 'flex'});
    } else {
      $('#sec-list .facilities[data-category="'+ LIST.category +'"] .item').each(function(){
        const thisTag = $(this).data('tags').split(',');
        // console.log(thisTag)
        
        if (LIST.tags.every(element => thisTag.includes(element)) === false) {
          $(this).hide();
        } else {
          $(this).css({display: 'flex'});
        }
      });
    }

  },
  resetTags: function() {
    LIST.tags = [];
    $('#sec-list .facilities .item').css({display: 'flex'});
    $('#list-filter .tag').removeClass('enabled');
  }
};